import { render, staticRenderFns } from "./SMSTemplateSettings.vue?vue&type=template&id=6e0e1f8f&scoped=true&"
import script from "./SMSTemplateSettings.vue?vue&type=script&lang=js&"
export * from "./SMSTemplateSettings.vue?vue&type=script&lang=js&"
import style0 from "./SMSTemplateSettings.vue?vue&type=style&index=0&id=6e0e1f8f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0e1f8f",
  null
  
)

export default component.exports